<template>
  <div class="profile-detail-block modal-prof-detail">
    <div class="row">
      <div class="col-md-7">
        <div class="profile-img d-flex align-items-center">
          <div class="prf-title">
            <h1>{{profile.last_name}} {{profile.name}}</h1>
            <h2>({{profile.last_furigana}} {{profile.furigana}})</h2>
            <h2 v-if="profile.position">{{profile.position.title}}</h2>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="profile-desc">
          <ul>
            <li class="d-flex">
              <i class="fa fa-calendar-minus-o" aria-hidden="true"></i>
              <span class="edit-txt">{{profile.birthDate}} ( {{profile.age}} )</span>
            </li>
            <li class="d-flex">
              <i class="fa fa-map-marker" aria-hidden="true"></i>
              <span class="edit-txt">{{profile.residence.title}}</span>
            </li>
            <li class="d-flex">
              <a :href="`mailto:${profile.email}`">
                <i class="fa fa-envelope" aria-hidden="true"></i>
                <span class="edit-txt">{{profile.email}}</span>
              </a>
            </li>
            <!-- <li class="d-flex"><i class="fa fa-phone" aria-hidden="true"></i>
              <span class="edit-txt">{{profile.phone}}</span>
            </li>-->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DBasicInfo',
  props: {
    profile: {
      required: true,
    },
  },
  mounted() {
    this.$emit('basicLoaded');
  },
};
</script>

<style scoped>
.modal-prof-detail.profile-detail-block {
  padding: 4px 20px;
}

.modal-prof-detail .prf-title h1 {
  font-size: 24px;
}

.modal-prof-detail .prf-title h2 {
  font-size: 16px;
}

.modal-prof-detail .profile-desc ul li {
  font-size: 14px;
  margin-bottom: 7px;
}

.modal-prof-detail .profile-img {
  min-height: 85px;
}

.modal-prof-detail .profile-desc {
  padding-bottom: 0;
}
</style>
